import styled from 'styled-components';
import { IThemeProvider } from '../../../styles/theme';

export const Wrapper = styled.div`
  width: 100%;
  box-sizing: border-box;
  padding-top: 20px;
`;

export const Table = styled.table`
  width: 100%;
`;

export const HeaderRow = styled.tr`
  display: grid;
  grid-template-columns: 2fr 1fr 1fr 3fr 1fr 1fr;
  padding-bottom: 4px;
`;

export const HeaderCell = styled.th<IThemeProvider>`
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  font-size: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  line-height: 16px;
  ${({ theme }) => `
    color:  ${theme.colors.neutral.primary[80]};
  `}
  &:first-child {
    margin-left: 2rem;
    justify-content: left;
  }
`;
